import React, { useState, useEffect } from 'react'
import Blockchains from '@depay/web3-blockchains'

const CLAIM_API = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"address","name":"owner","type":"address"}],"name":"ERC721IncorrectOwner","type":"error"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ERC721InsufficientApproval","type":"error"},{"inputs":[{"internalType":"address","name":"approver","type":"address"}],"name":"ERC721InvalidApprover","type":"error"},{"inputs":[{"internalType":"address","name":"operator","type":"address"}],"name":"ERC721InvalidOperator","type":"error"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"ERC721InvalidOwner","type":"error"},{"inputs":[{"internalType":"address","name":"receiver","type":"address"}],"name":"ERC721InvalidReceiver","type":"error"},{"inputs":[{"internalType":"address","name":"sender","type":"address"}],"name":"ERC721InvalidSender","type":"error"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ERC721NonexistentToken","type":"error"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"baseTokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"mint","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"}]

const CLAIM = {
  'polygon': {
    'blue': '0x4702Fed4817A0beAc0Ca4869d3b9d1aF3D6A9660',
    'pink': '0xF5a3e561E8f92CD5A4845B2f9aB70D6a39D547a5',
    'yellow': '0x61ec1cE3418B6116a18DAbb326Fd04174D214308',
  },
  'gnosis': {
    'blue': '0xd73dFeF8F9c213b449fB39B84c2b33FBBc2C8eD3',
    'pink': '0x69594057e2C0224deb1180c7a5Df9ec9d5B611B5',
    'yellow': '0xD1711710843B125a6a01FfDF9b95fDc3064BeF7A',
  },
  'avalanche': {
    'blue': '0xd73dFeF8F9c213b449fB39B84c2b33FBBc2C8eD3',
    'pink': '0x69594057e2C0224deb1180c7a5Df9ec9d5B611B5',
    'yellow': '0xD1711710843B125a6a01FfDF9b95fDc3064BeF7A',
  },
  'arbitrum': {
    'blue': '0xD1711710843B125a6a01FfDF9b95fDc3064BeF7A',
    'pink': '0xDE4d1e8c208893173d6c5Cf458d9Ac78495fb938',
    'yellow': '0xd73dFeF8F9c213b449fB39B84c2b33FBBc2C8eD3',
  },
  'optimism': {
    'blue': '0xDE4d1e8c208893173d6c5Cf458d9Ac78495fb938',
    'pink': '0x5CF9a182BBd5d9b7F8E2b93f8471852dA2a75014',
    'yellow': '0xD1711710843B125a6a01FfDF9b95fDc3064BeF7A',
  },
  'base': {
    'blue': '0x886eb82a7e5E7310F66A0E83748662A17E391eb0',
    'pink': '0xA1cfbeeF344A52e18f748fd6a126f9426A40fbc7',
    'yellow': '0x5CF9a182BBd5d9b7F8E2b93f8471852dA2a75014',
  },
}

export default ()=>{

  const [ selectedNft, setSelectedNft ] = useState()
  const [ selectedBlockchain, setSelectedBlockchain ] = useState()
  const [ mint, setMint ] = useState()
  const [ transactionUrl, setTransactionUrl ] = useState()

  useEffect(()=>{
    if(selectedNft && selectedBlockchain) {
      setMint(CLAIM[selectedBlockchain][selectedNft])
    } else {
      setMint()
    }
  }, [selectedNft, selectedBlockchain])

  const claimNow = async()=>{
    let { wallet } = await DePayWidgets.Connect()
    wallet.sendTransaction({
      blockchain: selectedBlockchain,
      to: mint,
      api: CLAIM_API,
      method: 'mint'
    }).then((sentTransaction)=>{
      setTransactionUrl(Blockchains[selectedBlockchain].explorerUrlFor({ transaction: sentTransaction }))
    })
  }

  return(
    <div className="container pb-5">
      
      <h6 className="opacity-5">Thank you for having tested DePay</h6>
      
      <h5 className="pt-4">1. Select the NFT you wish to claim</h5>
      
      <div className="row pt-4">

        <label className="col col-4" type="button">
          <div>
            <img className={`rounded-2 w-100 border ${selectedNft === 'blue' ? "border-primary" : "border-white"}`} src="https://img1.depay.com/public/i-have-tested-depay/blue.jpg"/>
          </div>
          <div className="text-center pt-2">
            <input type="radio" disabled={!!transactionUrl} name="nft" value="blue" onChange={()=>setSelectedNft('blue')}/>
          </div>
        </label>

        <label className="col col-4" type="button">
          <div>
            <img className={`rounded-2 w-100 border ${selectedNft === 'pink' ? "border-primary" : "border-white"}`} src="https://img1.depay.com/public/i-have-tested-depay/pink.jpg"/>
          </div>
          <div className="text-center pt-2">
            <input type="radio" disabled={!!transactionUrl} name="nft" value="pink" onChange={()=>setSelectedNft('pink')}/>
          </div>
        </label>

        <label className="col col-4" type="button">
          <div>
            <img className={`rounded-2 w-100 border ${selectedNft === 'yellow' ? "border-primary" : "border-white"}`} src="https://img1.depay.com/public/i-have-tested-depay/yellow.jpg"/>
          </div>
          <div className="text-center pt-2">
            <input type="radio" disabled={!!transactionUrl} name="nft" value="yellow" onChange={()=>setSelectedNft('yellow')}/>
          </div>
        </label>

      </div>

      <div className="pt-5">
        <h5 className="pb-2">2. Select the blockchain you want to receive the NFT on</h5>
      </div>

      <div className="text-center pt-3">

        { 
          ['polygon', 'base', 'arbitrum', 'optimism', 'avalanche', 'gnosis'].map((blockchainName)=>{
            let blockchain = Blockchains[blockchainName]
            if(blockchain.name === 'ethereum') { return null }
            return(
              <label key={ blockchain.name } className="d-inline-block text-center me-2" type="button" title={ blockchain.label }>
                <div>
                  <img style={{ width: '40px' }} className={`rounded-2 p-1 bg-white border ${selectedBlockchain === blockchain.name ? "border-primary" : "border-white"}`} src={ blockchain.logoWhiteBackground }/>
                </div>
                <div className="text-center">
                  <input type="radio" disabled={!!transactionUrl} name="blockchain" value={ blockchain.name } onChange={()=>setSelectedBlockchain(blockchain.name)}/>
                </div>
              </label>
            )
          })
        }
        
      </div>

      <div className="text-center pt-5 pb-6">

        <h5 className="pb-3">3. Finaly claim/mint your NFT</h5>

        { !transactionUrl &&
          <div>
            { mint && mint.match('https') &&
              <a href={mint} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg rounded-2">
                Claim now
              </a>
            }

            { mint && mint.match('0x') &&
              <button onClick={claimNow} className="btn btn-primary btn-lg rounded-2" type="button">
                Claim now
              </button>
            }

            { !mint &&
              <button onClick={()=>{}} disabled={true} className="btn btn-primary btn-lg rounded-2" type="button">
                Claim now
              </button>
            }
          </div>
        }

        { transactionUrl &&
          <a href={transactionUrl} target="_blank" rel="noopener noreferrer">
            { transactionUrl }
          </a>
        }

      </div>

    </div>
  )
}
